export default function () {
  window.addEventListener("load", () => {
    try {
      const line = document.querySelector(".js-panel-line");
      const btns = document.querySelectorAll(".js-panel-chapt");
      const blocks = document.querySelectorAll("[data-chapt-block]");

      clear_btns();
      clear_blocks();

      active_chapt(btns[0]);
      //
      btns.forEach((btn) => {
        let btn_info = btn.getBoundingClientRect();

        btn.style.width = `${btn_info.width}px`;
      });

      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          clear_btns();
          clear_blocks();
          active_chapt(btn);
        });
      });
      //

      function active_chapt(btn) {
        btn.classList.add("active");
        let path = btn.getAttribute("data-chapt-btn");

        let block = document.querySelector(`[data-chapt-block=${path}]`);
        block.classList.add("active");

        let btn_info = btn.getBoundingClientRect();
        let parent_info = btn.parentElement.getBoundingClientRect();
        calc_line(btn_info, parent_info);
      }

      function clear_btns() {
        btns.forEach((btn) => btn.classList.remove("active"));
      }

      function clear_blocks() {
        blocks.forEach((block) => block.classList.remove("active"));
      }

      function calc_line(info, parent_info) {
        const line = document.querySelector(".js-panel-line");
        console.log(info);
        console.log(parent_info);
        line.style.cssText = `
        left: ${info.left - parent_info.x}px;
        width: ${info.width + 2}px;
        `;
      }
    } catch (e) {}
  });
}
